module.exports = __webpack_public_path__ + "static/img/08ko.e8ef00c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/08ko.jpg
// module id = xjss
// module chunks = 0